import { EventEmitter } from 'events'
const { values, assoc, indexBy, prop } = require('ramda')

const MAX_EXECUTION_TIMEOUT = 60 * 1000 // 1 minute

export default class Queue extends EventEmitter {
  queue = []
  isExecuting = false
  worker
  options = {
    maxRetries: 0,
    retryDelay: 0,
    afterProcessDelay: 0,
    maxTimeout: 0,
  }

  constructor(worker, options) {
    super()

    this.worker = worker
    this.options = options
  }

  push(task, uniqueKey) {
    task.retries = this.options.maxRetries || 0
    const key = task.id.toString()

    if (uniqueKey) {
      this.queue = values(assoc(key, task, indexBy(prop(uniqueKey), this.queue)))
    } else {
      this.queue.push(task)
    }

    this.check()
  }

  get size() {
    return this.queue.length
  }

  execute(task) {
    const timer = setTimeout(() => {
      this.emit('taskTimedOut', task)
      this.retry(task, new Error('Timed out!'))
    }, this.options.maxTimeout || MAX_EXECUTION_TIMEOUT)

    const next = response => {
      clearTimeout(timer)
      if (response instanceof Error) {
        this.retry(task, response)
      } else {
        this.isExecuting = false
        this.check()
      }
    }

    try {
      this.worker(task, next)
    } catch (e) {
      this.retry(task, e)
    }
  }

  check() {
    if (!this.isExecuting && this.size) {
      this.isExecuting = true
      this.emit('start-working')
      const task = this.queue.shift()

      setTimeout(() => {
        this.execute(task)
      }, this.options.afterProcessDelay || 0)
    } else {
      this.emit('idle')
    }
  }

  retry(task, e) {
    if (--task.retries <= 0) {
      this.emit('taskFailed', { ...task, error: e?.message || 'N/A' })
    } else {
      this.queue = [...this.queue, task]
    }

    this.isExecuting = false
    this.check()
  }
}
